import type { DefaultResourceType } from './resources';
import { i18n as i18nCommon } from '@anywayseo/tools';

import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import resources from './resources';


declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: Extract<DefaultResourceType, 'common'>;
    resources: DefaultResourceType;
  }
}

i18n.use(initReactI18next).init({
  lng: process.env.GATSBY_SITE_LANGUAGE,
  fallbackLng: i18nCommon.language,
  resources,
});

i18n.on('languageChanged', (lang) => {
  i18nCommon.changeLanguage(lang);
});

export default i18n;
